import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { Button, Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import history from '../../../core/history';
// Locale
import messages from '../../../locale/messages';
import s from './ImageBanner.css';
const ImageBanner = ({ data }) => {

  const isAuthenticated = useSelector(state => state.runtime.isAuthenticated);

  const handleClick = () => {
    if (isAuthenticated) {
      history.push('/become-a-host?mode=new');
    } else {
      history.push('/login?refer=/become-a-host?mode=new');
    }
  }

  return (
    <div className={s.container}>
      <Grid>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <div className={cx(s.bgImage, s.bgImgeCenter)} style={{ backgroundImage: `url(/images/home/${data && data.whyhostBannerImage})` }}>
              <div>
                <h3 className={s.titleText}>{data && data.whyhostBannerHeading}</h3>
                <Button
                  className={s.btn}
                  onClick={handleClick}
                >
                  <FormattedMessage {...messages.becomeAHost} />
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

ImageBanner.propTypes = {
  formatMessage: PropTypes.any,
  refer: PropTypes.string,
};

ImageBanner.defaultProps = {
  isAuthenticated: false
};

export default withStyles(s)(ImageBanner);
